<script>
  let { lines = 3, class: className = "" } = $props();
</script>

<div class="animate-pulse space-y-3 {className}">
  {#each Array(lines) as _, i}
    <div
      class="h-4 bg-white/[0.08] rounded"
      style="width: {i === lines - 1 ? '60%' : '100%'}"
    ></div>
  {/each}
</div>
